export default "__VITE_ASSET__BKntrmWw__"